<style lang="less" scoped>
</style>
<template>
	<div>
		<v-row v-if="post">
			<v-col cols="12" md="4" v-if="post.showLogInForm && view == 'visitor'">
				<Login></Login>
			</v-col>
			<v-col>
				<div class="pa-4">
					<h1 class="mw-h1" v-if="post.displayTitle">{{post.title}}</h1>
					<div v-if="displayPost">
						<DisplayEditorPost v-if="post.elements" :post="post" ></DisplayEditorPost>
						<v-row v-else v-html="post.content"></v-row>
					</div>
					<div v-else>
						<p class="text-large">
							You do not have permission to view this page
						</p>
					</div>
				</div>
			</v-col>
		</v-row>
	</div>
</template>
<script>

import Vuex from 'vuex';
	import Login from "../../components/Login.vue"
	import DisplayEditorPost from "../edits/TextEditor/DisplayEditorPost.vue"
	export default {
	name: 'DisplayPost',
	props: {
		id: {type: String},
	},
	data: () => ({
	}),
	components: {
		Login: Login,
		DisplayEditorPost
	},
	computed: {
		...Vuex.mapState({
			view: state => state.auth.view,
			post( state ){
				var id = this.id;
				return state[state.auth.view].posts.find(a => a.id == id )
			}
		}),
		displayPost(){
			if( !this.post ){
				return false;
			}
			if( this.post.loggedInOnly && this.view == 'visitor' ){
				return false;
			}
			if( this.post.loggedInOnly && this.post.access ){
				if( this.post.access.indexOf( this.view ) < 0 ){
					return false;
				}
			}
			return true;
		}
	},
	created() {
		
		this.$store.dispatch("fetchPost", this.id );
	}
}
	</script>